<template>
  <BaseForm
    v-model="formModel"
    :schema="[
      {
        type: 'phoneOrEmail',
        name: 'phoneOrEmail',
        label: t('Телефон или почта'),
        attrs: { 'data-testid': 'auth-contact-input' },
        required: true,
      },
    ]"
    :when-handle-submit="handleSubmit"
  >
    <template #actions="{ nextTabindex }">
      <BaseButton
        with-full
        with-decor
        data-testid="auth-prev-btn"
        @click="emit('back')"
      >
        {{ t('Назад') }}
      </BaseButton>
      <BaseButton
        type="submit"
        with-full
        with-decor
        variant="primary"
        data-testid="auth-next-btn"
        :tabindex="nextTabindex"
      >
        {{ t('Далее') }}
      </BaseButton>
    </template>
  </BaseForm>
  <AuthContactDevelopersBlock class="auth-forgot-form__developers" />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { AuthContactDevelopersBlock, AuthMethod, useAccountStore } from '~/entities/auth'
import { REGEX_FOR_CHECK_EMAIL } from '~/shared/const'
import { BaseButton, BaseForm } from '~/shared/ui'
import i18n from '../model/AuthForgotForm.i18n.json'

const emit = defineEmits<{
  (e: 'success', method: AuthMethod): void
  (e: 'back'): void
}>()

const { t } = useI18n(i18n)
const accountStore = useAccountStore()
const { phoneOrEmail } = storeToRefs(accountStore)

const formModel = ref({ phoneOrEmail: phoneOrEmail.value })

async function handleSubmit(form: { phoneOrEmail: string }) {
  phoneOrEmail.value = form.phoneOrEmail
  const method = REGEX_FOR_CHECK_EMAIL.test(form.phoneOrEmail)
    ? AuthMethod.email
    : AuthMethod.phone
  emit('success', method)
}
</script>

<style lang="scss" scoped>
.auth-forgot-form__developers {
  margin-top: rem(21px);
}
</style>
